<div class="row">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'INTEGRATION.CREATE_ITEM_RECORD_TO_SHIP' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm" routerLink="/export/integrations/ozon">
                        <i class="bi bi-backspace"></i> {{ 'BACK_TO_LIST' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="addProduct()">
                        <i class="bi bi-plus-circle"></i> {{ 'INTEGRATION.ADD_ELEM' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()" [disabled]="form.invalid">
                        <i class="bi bi-save"></i> {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                    <div class="col-12">

                        <div formArrayName="products">

                            <div *ngFor="let offer of form.get('products')['controls']; let i = index;">

                                <div class="row" [formGroupName]="i" class="row offer-item">

                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="product_id_{{i}}"><span class="star">*</span> {{ 'PRODUCT.PRODUCTS_LIST' | translate }}</label>
                                            <ng-select  
                                                id="product_id_{{i}}"
                                                class="custom" 
                                                clearAllText="{{ 'CLEAN' | translate }}"
                                                notFoundText="{{ 'NO_DATA' | translate }}"
                                                bindLabel="name"
                                                bindValue="id"
                                                formControlName="id"
                                                [loading]="loading"
                                                [items]="products"
                                                (search)="getProducts($event.term)"
                                                (change)="getProducts()">
                                            </ng-select>
                                            <!-- <div *ngIf="errorMessages">
                                                <div *ngFor="let item of errorMessages.product_id">
                                                    <div class="text-error" *ngIf="validation(['offers', i, 'product_id'], item.type)">
                                                        {{ item.message | translate: item.options }}
                                                    </div>
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>

                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="name_{{i}}" class="label"><span
                                            class="star">*</span> {{ 'DENOMINATION' | translate }}</label>
                                            <input type="text" class="form-control" id="name_{{i}}"
                                            formControlName="name">
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="old_price_{{i}}" class="label"><span
                                                    class="star">*</span> {{ 'PRICE.OLD_PRICE' | translate }}</label>
                                            <input type="text" class="form-control" id="old_price_{{i}}"
                                                formControlName="old_price" mask="separator">
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="premium_price_{{i}}" class="label"><span
                                                    class="star">*</span> {{ 'PRICE.PREMIUM_PRICE' | translate }}</label>
                                            <input type="text" class="form-control" id="premium_price_{{i}}"
                                                formControlName="premium_price" mask="separator">
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="price_{{i}}" class="label"><span
                                                    class="star">*</span> {{ 'PRICE.PRICE' | translate }}</label>
                                            <input type="text" class="form-control" id="price_{{i}}"
                                                formControlName="price" mask="separator">
                                        </div>
                                    </div>

                                   

                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="dimension_unit_{{i}}" class="label"><span
                                            class="star">*</span> {{ 'PRICE.DIMENSIONAL_UNIT' | translate }}</label>
                                             <ng-select  
                                                class="custom" 
                                                clearAllText="{{ 'CLEAN' | translate }}"
                                                notFoundText="{{ 'NO_DATA' | translate }}"
                                                bindLabel="name"
                                                bindValue="name"
                                                formControlName="dimension_unit"
                                                [loading]="loading"
                                                [items]="dimensions">
                                             </ng-select>
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="weight_unit_{{i}}" class="label"><span
                                            class="star">*</span> {{ 'PRICE.WEIGHT_UNIT' | translate }}</label>
                                             <ng-select  
                                                class="custom" 
                                                clearAllText="{{ 'CLEAN' | translate }}"
                                                notFoundText="{{ 'NO_DATA' | translate }}"
                                                bindLabel="name"
                                                bindValue="name"
                                                formControlName="weight_unit"
                                                [loading]="loading"
                                                [items]="weightUnits">
                                             </ng-select>
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="vat_{{i}}" class="label"><span
                                            class="star">*</span> {{ 'ORGANIZATION.VAT' | translate }}</label>
                                             <ng-select  
                                                class="custom" 
                                                clearAllText="{{ 'CLEAN' | translate }}"
                                                notFoundText="{{ 'NO_DATA' | translate }}"
                                                bindLabel="name"
                                                bindValue="id"
                                                formControlName="vat"
                                                [loading]="loading"
                                                [items]="vat">
                                             </ng-select>
                                        </div>
                                    </div>


                                    <div class="col-12 offer-btn-box">
                                        <button *ngIf="form.get('products').value.length > (i+1)" type="button"
                                            class="btn btn-danger btn-sm" (click)="removeOffer(i)">
                                            <i class="bi bi-x-circle"></i> {{ 'DELETE' | translate }}
                                        </button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </form>

            </div>

        </div>

    </div>
</div>